// Superadmin Pipeline (209) — sdílené výpočty nad řádkem firmy z GET /admin/companies.
// Každá firma je právě v jednom segmentu (Aktivní / Pozastavené / Archiv / Testovací)
// a aktivní právě v jednom sloupci tabule (V demu → Platí → Fakturovat → Čeká na úhradu).

export const TZ = "Europe/Prague";
export const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
export const todayIso = () => new Date().toLocaleDateString("sv-SE", { timeZone: TZ });
export const pragueDay = (iso) => (String(iso).length <= 10 ? String(iso) : new Date(iso).toLocaleDateString("sv-SE", { timeZone: TZ }));
export const day = (iso) => { if (!iso) return "—"; const [y, m, d] = pragueDay(iso).split("-").map(Number); return `${d}. ${m}. ${y}`; };
export const dayShort = (iso) => { if (!iso) return "—"; const [, m, d] = pragueDay(iso).split("-").map(Number); return `${d}. ${m}.`; };
export const daysTo = (iso) => {
  if (!iso) return null;
  const a = new Date(`${todayIso()}T12:00:00Z`), b = new Date(`${pragueDay(iso)}T12:00:00Z`);
  return Math.round((b - a) / 86400000);
};
export const dny = (n) => (n === 1 ? "den" : n >= 2 && n <= 4 ? "dny" : "dní");
export const plusDays = (iso, n) => { const d = new Date(`${pragueDay(iso)}T12:00:00Z`); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); };

const COLORS = ["#1f6b52", "#8a5a00", "#2f5f9e", "#9b3b6a", "#6a4fb0", "#a3481f", "#3f6f2f"];
export const initials = (n) => {
  const words = String(n || "?").replace(/[,.]?\s*(s\.\s?r\.\s?o\.?|a\.\s?s\.|spol\..*)$/i, "").split(/\s+/).filter(Boolean);
  return (words.length > 1 ? words.slice(0, 2).map((w) => w[0]).join("") : (words[0] || "?").slice(0, 2)).toUpperCase();
};
export const colorOf = (id) => COLORS[[...String(id)].reduce((a, ch) => a + ch.charCodeAt(0), 0) % COLORS.length];

export const PAID_PLANS = [["zaklad", "Starter"], ["stavba", "Profi"], ["firma", "Business"]];
export const CYCLE_MONTHS = { month: 1, half: 6, year: 12 };
export const CYCLE_ADV = { month: "měsíčně", half: "pololetně", year: "ročně" };
export const CYCLE_PERIOD = { month: "měsíc", half: "pololetí", year: "rok" };

export const isStripe = (r) => (r.billing?.mode === "stripe") || !!r.has_subscription;
export const periodAmount = (r) => (r.price || 0) * (CYCLE_MONTHS[r.billing?.cycle || "month"] || 1);
// Kolik firma dluží za období: Stripe roční = 10× měsíc (config STRIPE_PRICE_*_YEAR), faktura = cena × měsíce období.
export const owedAmount = (r) => (isStripe(r) ? (r.price || 0) * (r.plan_cycle === "year" ? 10 : 1) : periodAmount(r));
// Platící firma = má placený tarif (i když čeká na úhradu nebo je za neplacení zamčená); testovací ne.
export const isPaying = (r) => !r.is_test && ["plati", "ceka_uhrada", "nezaplaceno"].includes(r.display_status?.key);
// Faktura patří k aktuálnímu období jen tehdy, když je vystavená na stávající „zaplaceno do“.
export const currentInvoice = (b = {}) => (b.next_invoice && b.next_invoice.for === b.paid_until ? b.next_invoice : null);

export const SEGMENTS = [
  ["aktivni", "Aktivní"], ["pauza", "Pozastavené"], ["archiv", "Archiv"], ["test", "Testovací"],
];
export function segOf(r) {
  if (r.is_test) return "test";
  const k = r.display_status?.key;
  if (k === "ukonceno") return "archiv";
  if (k === "pozastaveno" || k === "nezaplaceno" || k === "demo_vyprselo") return "pauza";
  if (k === "ceka_uhrada" && r.state === "blocked") return "pauza";     // kartou nezaplaceno a už zamčeno
  return "aktivni";
}

export const COLUMNS = [
  ["demo", "V demu"], ["plati", "Platí"], ["fakt", "Fakturovat"], ["ceka", "Čeká na úhradu"],
];
export function colOf(r) {
  const k = r.display_status?.key;
  if (k === "demo_bezi") return "demo";
  if (k === "ceka_uhrada") return "ceka";
  if (r.billing?.phase === "invoice_due") return "fakt";
  return "plati";
}

const byName = (a, b) => String(a.name).localeCompare(String(b.name), "cs");
const SORT = {
  demo: (a, b) => String(a.trial_ends_at).localeCompare(String(b.trial_ends_at)) || byName(a, b),
  plati: (a, b) => (b.price || 0) - (a.price || 0) || byName(a, b),
  fakt: (a, b) => String(a.billing?.next_start).localeCompare(String(b.billing?.next_start)) || byName(a, b),
  ceka: (a, b) => String(a.billing?.lock_on || "9").localeCompare(String(b.billing?.lock_on || "9")) || byName(a, b),
  pauza: (a, b) => byName(a, b),
  archiv: (a, b) => String(b.status_at || "").localeCompare(String(a.status_at || "")) || byName(a, b),
  test: byName,
};
export const sortFor = (key) => SORT[key] || byName;

// Navržený tarif pro platební odkaz z dema: kdo by se do Starteru nevešel, dostane Profi.
export const recommendPlan = (r) => ((r.user_count || 0) > 3 || (r.active_projects || 0) > 3 ? "stavba" : "zaklad");

export const pl = (n, one, few, many) => (n === 1 ? one : n >= 2 && n <= 4 ? few : many);
export const activity = (r) => `${r.active_projects || 0} ${pl(r.active_projects || 0, "zakázka", "zakázky", "zakázek")} · ${r.user_count || 0} ${pl(r.user_count || 0, "uživatel", "uživatelé", "uživatelů")}`;
